import React, { useEffect } from 'react';
import { visualDomDiff } from 'visual-dom-diff';

function AppTextDifference({ sourceText = '', newText = '' }) {
  const updateDiff = () => {
    const output = document.getElementById('output');
    output.innerHTML = '';
    output.appendChild(
      visualDomDiff(document.getElementById('sourceHtml'), document.getElementById('newHtml'))
    );
  };
  useEffect(() => {
    updateDiff();
  }, [sourceText, newText]);

  return (
    <div className="col-lg-12 row">
      <div className="col-lg-4">
        <h2>Current Content</h2>
        <div id="sourceHtml">{sourceText}</div>
      </div>
      <div className="col-lg-4">
        <h2>Preview Content</h2>
        <div id="newHtml">{newText}</div>
      </div>
      <div className="col-lg-4">
        <h2>Difference</h2>
        <div id="output"></div>
      </div>
    </div>
  );
}

export default AppTextDifference;
